import styled from 'styled-components';

import { fromLarge, fromMedium, toMedium } from 'styleUtils/mediaQueries';
import { gridRow, GridStartEndAttributes, gridColumn, gridDisplay } from 'styleUtils/grid';
import { GridItem } from './GridItem';

const defaultLetsMeetColumn: GridStartEndAttributes = { start: 1 };
const meetRightLetsMeetColumn: GridStartEndAttributes = { start: 3 };

const defaultLetsMeetRow: GridStartEndAttributes = { start: 2, end: 4 };
const offsetMeetLetsMeetRow: GridStartEndAttributes = { start: 3, end: 6 };
const hasImageLetsMeetRow: GridStartEndAttributes = { start: 3, end: 5 };

export const LetsMeetWrapper = styled.div<GridItem>`
    ${gridColumn({ start: 1 })}
    ${gridRow({ start: 2 })}
    align-content: center;

    ${toMedium`
        margin: 1.5rem 0;
  `};

    ${fromMedium`
        ${gridDisplay()}
        ${gridColumn({ start: 2 })}
        ${gridRow({ start: 1 })}
        
        ${({ meetRight }): string => {
            return gridColumn({ start: meetRight ? 2 : 1 });
        }}
  `};

    ${fromLarge`
    
    align-content: flex-start;

    ${({ meetRight }): string => {
        return gridColumn(meetRight ? meetRightLetsMeetColumn : defaultLetsMeetColumn);
    }}

    ${({ hasImage: hasImage, offsetMeet }): string => {
        if (hasImage) {
            return gridRow(hasImageLetsMeetRow);
        }

        if (offsetMeet) {
            return gridRow(offsetMeetLetsMeetRow);
        }

        return gridRow(defaultLetsMeetRow);
    }}
  `};
`;
